import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Typography } from "@mantine/core";
import type { FC } from "react";
import type { ResponseStatus } from "src/api/Tmd.dtos";
import AppSettings from "src/AppSettings";

export type ResponseStatusAlertProps = {
    responseStatus?: ResponseStatus | null | undefined;
};

const ResponseStatusAlert: FC<ResponseStatusAlertProps> = ({ responseStatus }) => {
    if (!responseStatus) {
        return null;
    }

    return (
        <Alert
            color="error"
            icon={<FontAwesomeIcon icon={AppSettings.icons.error.medium} />}
            title={responseStatus.errorCode ?? "Error"}
        >
            <Typography>{responseStatus.message}</Typography>
        </Alert>
    );
};

export default ResponseStatusAlert;
